export default "__VITE_PUBLIC_ASSET__fd854770__"